export default async () => {
    // set listeners for two buttons near the breadcrumb - scroll to reviews and scroll to map

    const tfAnchorsReviews = document.querySelector("#tf-anchors-reviews");
    const tfAnchorsMap = document.querySelector("#tf-anchors-map");
    const tfAnchorsPlanning = document.querySelector("#tf-anchors-planning");

    if (tfAnchorsReviews)
        tfAnchorsReviews.addEventListener("click", () => {
            window.dispatchEvent(
                new CustomEvent("smoothScrollToSelector", {
                    detail: {
                        selector: "#tf-reviews",
                    },
                })
            );
        });
    if (tfAnchorsMap)
        tfAnchorsMap.addEventListener("click", () => {
            window.dispatchEvent(
                new CustomEvent("smoothScrollToSelector", {
                    detail: {
                        selector: "#tf-map",
                    },
                })
            );
        });
    tfAnchorsPlanning.addEventListener("click", () => {
        window.dispatchEvent(
            new CustomEvent("smoothScrollToSelector", {
                detail: {
                    selector: "#tf-planning",
                },
            })
        );
    });
};
